const alias = 'AGENT_PARTNER';

export const GET_SUB_AGENT_BRANCHES_REQUEST = `GET_${alias}_SUB_AGENT_BRANCHES_REQUEST`;
export const GET_SUB_AGENT_BRANCHES_SUCCESS = `GET_${alias}_SUB_AGENT_BRANCHES_SUCCESS`;
export const GET_SUB_AGENT_BRANCHES_FAILURE = `GET_${alias}_SUB_AGENT_BRANCHES_FAILURE`;

export const GET_SUPER_AGENT_BRANCHES_REQUEST = `GET_${alias}_SUPER_AGENT_BRANCHES_REQUEST`;
export const GET_SUPER_AGENT_BRANCHES_SUCCESS = `GET_${alias}_SUPER_AGENT_BRANCHES_SUCCESS`;
export const GET_SUPER_AGENT_BRANCHES_FAILURE = `GET_${alias}_SUPER_AGENT_BRANCHES_FAILURE`;
